export default "__VITE_ASSET__f7ca6575__"